import React, { useState } from 'react'
import { Button, CollapsibleHeader, Separator, Title } from '../../style'
import { ChevronDown, ChevronUp } from 'lucide-react'
import DeadlinesSection from '../Deadlines'
import HeatTreamentSection from '../HeatTreatment'
import PricesSection from '../Prices'
import RequestedItem from './Requested'
import OfferedItem from './Offered'
import { ManageOrderStateByProduct } from '../..'

export interface OrderProduct {
  product: any
  format: any  
  diameter: any
  thickness: any
  length: any
  finishing: any
  weigth: any
  quantity: any
  specs: any
}

export interface ItemOrderType {
  requestedProduct: OrderProduct
  offeredProduct: OrderProduct
}

export interface RequestedOrOfferedItemProps {
  item: ItemOrderType
  setItem: React.Dispatch<React.SetStateAction<ItemOrderType>>
}

const ProductSection: React.FC<ManageOrderStateByProduct> = ({ order, setOrder, index }) => {
  const [ isDetailsOpen, setIsDetailsOpen ] = useState(true)
  
  return(
    <>
      <CollapsibleHeader onClick={() => setIsDetailsOpen(!isDetailsOpen)}>
        <Title>Adicionar produto</Title>
        <Button>
          {isDetailsOpen ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
        </Button>
      </CollapsibleHeader>
      {isDetailsOpen && (
      <>
        <RequestedItem order={order} setOrder={setOrder} index={index} />
        <OfferedItem order={order} setOrder={setOrder} index={index}/>
        <Separator/>
        {/* <DeadlinesSection /> */}
        {/* <Separator /> */}
        {/* <HeatTreamentSection />  */}
        {/* <Separator /> */}
        <PricesSection />
      </>
      )}
    </>
  )
}

export default ProductSection